import React from "react";

const DeileryIcon = (props:any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8" clipPath="url(#clip0_2511_12414)">
          <path
            d="M9.65 18.0001C8.9547 18.0001 8.29 17.7196 6.96145 17.1603C3.6541 15.7671 2 15.071 2 13.8988V5.71076M9.65 18.0001C10.3453 18.0001 11.01 17.7196 12.3386 17.1603C15.6459 15.7671 17.3 15.071 17.3 13.8988V5.71076M9.65 18.0001V9.52556C10.4745 9.52556 11.2404 9.15581 12.7738 8.41631L15.2558 7.21781C16.6183 6.56076 17.3 6.23181 17.3 5.71076M2 5.71076C2 6.23181 2.6817 6.55991 4.04425 7.21696L6.52625 8.41546C8.05965 9.15496 8.8255 9.52386 9.65 9.52386M2 5.71076C2 5.19056 2.6817 4.86161 4.04425 4.20456L5.4 3.55006M17.3 5.71076C17.3 5.19056 16.6183 4.86161 15.2558 4.20456L13.9383 3.56876M4.55 10.3722L6.25 11.2196M9.6466 6.95006V1.00005M9.6466 1.00005C9.42305 0.996654 9.2029 1.15305 9.0397 1.3443L7.95 2.64736M9.6466 1.00005C9.8625 1.0026 10.081 1.15815 10.2535 1.3443L11.35 2.64736"
            stroke={props?.color ?? "black"}
            strokeWidth="1.275"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2511_12414">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default DeileryIcon;
